export default {"src":"/_next/static/media/colx.bbdb01db.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};